import { render, staticRenderFns } from "./InfoMessage.vue?vue&type=template&id=6d52d559&scoped=true&"
import script from "./InfoMessage.vue?vue&type=script&lang=js&"
export * from "./InfoMessage.vue?vue&type=script&lang=js&"
import style0 from "./InfoMessage.vue?vue&type=style&index=0&id=6d52d559&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d52d559",
  null
  
)

export default component.exports